import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';
import useVehicleCategory from '../driver-setup/useVehicleCategory';
import useBusinessInfo from './useBusinessInfo';

const useUpdateBusinessInfo = () => {
    const request = useHttps();
    const { businessInfo } = useBusinessInfo();
    const { getVehicleCategory } = useVehicleCategory();
    const [loading, setLoading] = useState(false);

    const onUpdateBusinessInfoError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while updating the business information.',
        );
    };

    const onUpdateBusinessInfoSuccess = (callbackFn: () => void) => ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Business information updated successfully.',);
        callbackFn();
        businessInfo();
        getVehicleCategory();
    };

    const updateBusinessInfo = (data: any, callbackFn?: () => void) => {
        const formData = new FormData();

        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });

        const url: HttpConfig = {
            url: 'api/v1/company/update-details',
            method: 'patch',
            data: formData
        };

        request(url, onUpdateBusinessInfoSuccess(callbackFn ?? (() => {})), setLoading, onUpdateBusinessInfoError);
    };

    return { updateBusinessInfo, loading };
};

export default useUpdateBusinessInfo;
